import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';


import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';

import { LoadingComponent } from 'src/app/shared/loading/loading.component';
import { TokenExpiredComponent } from 'src/app/shared/token-expired/token-expired.component';
import { InternalServerErrorComponent } from 'src/app/shared/internal-server-error/internal-server-error.component';
import { ModalPrevisualizarGameComponent } from 'src/app/components/game-history/modal-previsualizar-game/modal-previsualizar-game.component';
import { ModalPublicGameComponent } from 'src/app/components/game-history/modal-public-game/modal-public-game.component';
import { MatCardModule } from '@angular/material/card';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


@NgModule({
  declarations: [
    LoadingComponent,
    TokenExpiredComponent,
    InternalServerErrorComponent,
    ModalPublicGameComponent,
    ModalPrevisualizarGameComponent
  ],
  imports: [
    CommonModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    MatCardModule,
    FormsModule,
    ReactiveFormsModule,

  ],
  exports:[
    LoadingComponent,
    TokenExpiredComponent,
    InternalServerErrorComponent,
    ModalPublicGameComponent,
    ModalPrevisualizarGameComponent
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class SharedModule { }
